export const Feature = {
  SHORTLIST: 'SHORTLIST',
} as const;

export type Feature = (typeof Feature)[keyof typeof Feature];

export type DailyFeature = {
  // client only field
  nextLevelConfig:
    | {
        [K in CompanyFeature]: number;
      }
    | null
    | undefined;
  dailyLimitResetTime: string | null;
  dailyCount: number;
  isDailyLimited: boolean;
  dailyMax: number | null;
};

export type QuotaSource = {
  count: number;
  max: number;
  remaining: number;
  expiryDateTime: string | null;
};

export type ShortlistQuota = {
  isUnlimited: boolean;
  totalRemaining: number;
  monthly: QuotaSource;
  addOn: QuotaSource;
  planBenefit: QuotaSource;
};

export type HotJobQuota = {
  id: string;
  title: string;
  quotas?: Partial<Record<Feature, QuotaSource>>;
};

export type HotJobsFeatureCount = {
  jobs: HotJobQuota[];
  nextCursor: string;
  hasMore: boolean;
};

export type FeatureCount = {
  company: {
    companyId: string;
    daily: { [K in Feature]: DailyFeature } | null;
    quotas?: Partial<Record<Feature, ShortlistQuota>>;
  };
};

export type JobFeatureCount = {
  jobId: string;
  daily: { [K in Feature]: DailyFeature } | null;
  quotas?: Partial<Record<Feature, QuotaSource>>;
};

export type FeatureCountWithJob = {
  job: JobFeatureCount;
} & FeatureCount;

export const CompanyFeature = {
  SHORTLIST_DAILY: 'SHORTLIST_DAILY',
  SHORTLIST_30DAYS: 'SHORTLIST_30DAYS',
  SHORTLIST_QUOTA: 'SHORTLIST_QUOTA',
  SHORTLIST_3DAYS: 'SHORTLIST_3DAYS',
  SHORTLIST_7DAYS: 'SHORTLIST_7DAYS',
  SHORTLIST_14DAYS: 'SHORTLIST_14DAYS',
} as const;

export type CompanyFeature =
  (typeof CompanyFeature)[keyof typeof CompanyFeature];

export const CompanyFeatureTypes = {
  DEFAULT: 'DEFAULT',
  VIP: 'VIP',
  SUBSCRIPTION: 'SUBSCRIPTION',
  CUSTOM_VIP_LOCATION: 'CUSTOM_VIP_LOCATION',
  CUSTOM_TRIAL_LOCATION: 'CUSTOM_TRIAL_LOCATION',
  CUSTOM_SUBSCRIPTION_LOCATION: 'CUSTOM_SUBSCRIPTION_LOCATION',
  CUSTOM_FREE_LOCATION: 'CUSTOM_FREE_LOCATION',
} as const;

export type CompanyFeatureTypes =
  (typeof CompanyFeatureTypes)[keyof typeof CompanyFeatureTypes];

export type CompanyFeatureConfig = {
  [K in CompanyFeatureTypes]?: {
    [K in CompanyFeature]: number;
  };
};

export const JobFeatureTypes = {
  HOT_JOB: 'HOT_JOB',
} as const;
export type JobFeatureTypes =
  (typeof JobFeatureTypes)[keyof typeof JobFeatureTypes];

export type JobFeatureConfig = {
  [K in JobFeatureTypes]?: {
    [K in CompanyFeature]: number;
  };
};
